import { OrderDetails } from "../shared/types/dashboard";
import { isSameDay } from "date-fns";

export const parseNumber = (value: string | number | undefined): number => {
  if (!value) return 0;
  return typeof value === "string" ? parseFloat(value) || 0 : value;
};

export const filterValidOrders = (orders: OrderDetails[]) =>
  orders.filter((order) => {
    if (!order) return false;

    const grandTotal = parseNumber(order.Finalamount);
    const subtotal = parseNumber(order.totalAmount);
    const totalAmount = order.totalAmount || 0;

    const hasValidTotal = grandTotal > 0 || subtotal > 0 || totalAmount > 0;
    const hasProducts = order.Products?.length > 0;

    return hasValidTotal && hasProducts;
  });

export const sumSales = (orders: OrderDetails[]) => orders.reduce((sum, order) => sum + parseNumber(order.Finalamount), 0);

export const filterOrdersByHour = (orders: OrderDetails[], date: Date, hour: number) =>
  orders.filter((order) => {
    if (!order.Orderdate) return false;
    try {
      const orderDate = new Date(order.Orderdate);
      const orderHour = parseInt(order.Ordertime?.split(":")[0] || "12");
      return isSameDay(orderDate, date) && orderHour === hour;
    } catch {
      return false;
    }
  });

export const filterOrdersByDay = (orders: OrderDetails[], date: Date) =>
  orders.filter((order) => {
    if (!order.Orderdate) return false;
    try {
      return isSameDay(new Date(order.Orderdate), date);
    } catch {
      return false;
    }
  });
